module.exports = __webpack_public_path__ + "static/media/20170806_49day_2380AT.9f78890b.jpg";